export default __webpack_public_path__ + "static/cloud-419de0a745c4f2394ac3c862b84104bf.png";